var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tarja-top"},[_vm._v(" "+_vm._s(_vm.localData)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }